import { render } from "./IconFile.vue?vue&type=template&id=290ee53e"
import script from "./IconFile.vue?vue&type=script&lang=ts"
export * from "./IconFile.vue?vue&type=script&lang=ts"
script.render = render

export default script